// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".select {\n  width: 100%;\n}\n.select > .title > .placeholder {\n  color: #999999;\n}\n.popup.select-dropdown > .content {\n  overflow: hidden;\n}\n.popup.select-dropdown > .content > .listbox {\n  height: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
